import { render, staticRenderFns } from "./BodegaDetalle.vue?vue&type=template&id=97b0fe38"
import script from "./BodegaDetalle.vue?vue&type=script&lang=js"
export * from "./BodegaDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports